export const removeSecond = (time?: string): string => (time ? time.replace(/:\d\d$/, '') : '');
